var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgManageSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "manage_search_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 21,
  height: 20
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M.5 0h20v20H.5z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#manage_search_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 15.833a.806.806 0 0 1-.594-.24.807.807 0 0 1-.24-.593c0-.236.08-.434.24-.594.16-.16.357-.24.593-.24h6.667c.236 0 .434.08.594.24.16.16.24.358.24.594s-.08.434-.24.594a.807.807 0 0 1-.594.24H2.999Zm0-4.166a.806.806 0 0 1-.594-.24.806.806 0 0 1-.24-.594c0-.236.08-.434.24-.593.16-.16.357-.24.593-.24h2.5c.236 0 .434.08.594.24.16.16.24.357.24.593s-.08.434-.24.594a.806.806 0 0 1-.594.24H3ZM3 7.5a.806.806 0 0 1-.594-.24.806.806 0 0 1-.24-.593c0-.236.08-.434.24-.594.16-.16.357-.24.593-.24h2.5c.236 0 .434.08.594.24.16.16.24.358.24.594s-.08.434-.24.593a.806.806 0 0 1-.594.24H3Zm9.166 5.833c-1.153 0-2.135-.406-2.948-1.218C8.406 11.302 8 10.319 8 9.167c0-1.153.407-2.136 1.22-2.948C10.03 5.406 11.012 5 12.165 5s2.135.406 2.948 1.219c.812.812 1.219 1.795 1.219 2.948 0 .402-.06.802-.177 1.198-.118.395-.295.76-.532 1.093l2.625 2.625a.79.79 0 0 1 .23.584.79.79 0 0 1-.23.583.79.79 0 0 1-.583.23.79.79 0 0 1-.583-.23l-2.625-2.625a3.716 3.716 0 0 1-1.094.531 4.17 4.17 0 0 1-1.198.177Zm0-1.666a2.41 2.41 0 0 0 1.77-.73 2.41 2.41 0 0 0 .73-1.77 2.41 2.41 0 0 0-.73-1.771 2.41 2.41 0 0 0-1.77-.73 2.41 2.41 0 0 0-1.77.73 2.41 2.41 0 0 0-.73 1.77c0 .695.243 1.285.73 1.771.485.487 1.076.73 1.77.73Z",
  fill: "#fff"
}))));
export default SvgManageSearch;